import React, { FC } from 'react';

import clsx from 'clsx';

import styles from './WysiwygPresenter.module.scss';

export type WysiwygPresenterProps = {
    content: string;
    className?: string;
};

const wysiwygReplaceRules: [string, string][] = [
    ['[responsive-embed]', `<div class="${styles.responsiveEmbed}">`],
    ['[/responsive-embed]', '</div>'],
    ['<table', `<div class="${styles.tableWrapper}"><table`],
    ['</table>', '</table></div>'],
    ['[icon-link]<a', `<a class="${styles.iconLink}" `],
    ['</a>[/icon-link]', '</a>'],
];

const mapWysiwygSectionContent = (content: string): string => {
    return wysiwygReplaceRules.reduce((acc, cur) => {
        const [searchValue, replaceValue] = cur;
        if (!acc.includes(searchValue)) return acc;
        return acc.replaceAll(searchValue, replaceValue);
    }, content);
};

export const WysiwygPresenter: FC<WysiwygPresenterProps> = (props) => {
    const { className, content } = props;

    return (
        <div
            className={clsx(styles.root, className)}
            dangerouslySetInnerHTML={{ __html: mapWysiwygSectionContent(content) }}
        />
    );
};
